const apolloCacheConfig = {
  typePolicies: {
    Query: {
      fields: {
        appointmentBundles: {
          keyArgs: ['id', 'kind']
        }
      }
    }
  }
};
export default apolloCacheConfig;